var map = {
	"./cs.json": "33RA",
	"./da.json": "haJr",
	"./de.json": "rMQE",
	"./default.json": "Hy88",
	"./en.json": "TcZl",
	"./es.json": "Q8Zg",
	"./et.json": "4hoS",
	"./fi.json": "7a6g",
	"./fr.json": "QonL",
	"./it.json": "VQBO",
	"./lv.json": "i566",
	"./nb.json": "QMXF",
	"./nl.json": "7k3L",
	"./pl.json": "68Fb",
	"./r3-sv.json": "VIbf",
	"./ru.json": "D4rJ",
	"./sk.json": "rSqS",
	"./sr.json": "ZDl9",
	"./sv.json": "ptGZ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tU2E";